import React, { useEffect, useState } from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();
  const [version, setVersion] = useState(null);

  useEffect(() => {
    fetch('/version.json')
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => data && setVersion(data))
      .catch(() => {});
  }, []);

  return (
    <footer className='w-full bg-white'>
      <div
        className='container p-3 flex justify-between items-center'
        style={{ color: '#166078', fontFamily: '"Lato", sans-serif', fontWeight: 200, fontSize: '14px', lineHeight: '20px' }}
      >
        <p className='mb-0'>HansePay © {currentYear}</p>
        <div className='flex items-center gap-2'>
          {version && (
            <>
              <span className='opacity-80'>
                UI {version.version?.uiVersion ?? '—'} · {version.env ?? '—'}
              </span>
              <div className='w-1 h-1 rounded-full bg-current' />
            </>
          )}
          <a href='https://www.hansepay.de/legal#terms' target='_blank' rel='noreferrer' className='hover:opacity-80 transition-opacity'>
            Terms of Service
          </a>
          <div className='w-1 h-1 rounded-full bg-current' />
          <a href='https://www.hansepay.de/legal#privacy' target='_blank' rel='noreferrer' className='hover:opacity-80 transition-opacity'>
            Privacy Policy
          </a>
          <div className='w-1 h-1 rounded-full bg-current' />
          <a href='mailto:hello@hansepay.de' className='hover:opacity-80 transition-opacity'>
            Support
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
